export interface PortfolioProject {
  id: string;
  title: string;
  category: 'desenvolvimento-web' | 'microsolda' | 'manutencao' | 'infraestrutura-rede' | 'automacao-residencial' | 'energia-solar' | 'desenvolvimento-sistemas';
  categoryLabel: string;
  description: string;
  clientName?: string;
  date: string; // formato YYYY-MM-DD
  beforeImage: string;
  afterImage: string;
  tags: string[];
  featured: boolean; // para destacar na página inicial ou nas páginas de serviço
}

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 'sistema-erp-personalizado',
    title: 'Sistema ERP Personalizado',
    category: 'desenvolvimento-sistemas',
    categoryLabel: 'Desenvolvimento de Sistemas',
    description: 'Desenvolvimento de sistema ERP completo para gestão de estoque, financeiro, vendas e relacionamento com clientes.',
    clientName: 'Distribuidora ABC',
    date: '2023-11-15',
    beforeImage: '/images/portfolio/sistema-erp-before.jpg',
    afterImage: '/images/portfolio/sistema-erp-after.jpg',
    tags: ['ERP', 'Gestão', 'Dashboard'],
    featured: true
  },
  {
    id: 'website-web-imports',
    title: 'Redesign de Site Comercial',
    category: 'desenvolvimento-web',
    categoryLabel: 'Desenvolvimento Web',
    description: 'Redesign completo do site da Web Imports, modernização, otimização para SEO e melhorias de desempenho.',
    clientName: 'Web Imports',
    date: '2025-03-28',
    beforeImage: '/images/portfolio/web-before-1.jpg',
    afterImage: '/images/portfolio/web-after-1.jpg',
    tags: ['redesign', 'responsivo', 'SEO'],
    featured: false
  },
  {
    id: 'website-empresa-x',
    title: 'Redesign de Site Corporativo',
    category: 'desenvolvimento-web',
    categoryLabel: 'Desenvolvimento Web',
    description: 'Redesign completo do site da Empresa X, incluindo nova identidade visual, otimização para SEO e melhorias de desempenho.',
    clientName: 'Empresa X',
    date: '2023-08-15',
    beforeImage: '/images/portfolio/web-before-1.jpg',
    afterImage: '/images/portfolio/web-after-1.jpg',
    tags: ['redesign', 'responsivo', 'SEO'],
    featured: true
  },
  {
    id: 'sistema-gestao-clinica',
    title: 'Sistema de Gestão para Clínica Médica',
    category: 'desenvolvimento-web',
    categoryLabel: 'Desenvolvimento Web',
    description: 'Desenvolvimento de sistema completo para agendamento de consultas, prontuário eletrônico e gestão financeira.',
    clientName: 'Clínica Saúde Integral',
    date: '2023-06-10',
    beforeImage: '/images/portfolio/sistema-clinica-before.jpg',
    afterImage: '/images/portfolio/sistema-clinica-after.jpg',
    tags: ['saúde', 'sistema web', 'agendamento'],
    featured: true
  },
  {
    id: 'recuperacao-placa-mae',
    title: 'Recuperação de Placa-Mãe de MacBook Pro',
    category: 'microsolda',
    categoryLabel: 'Microsolda Especializada',
    description: 'Reparo complexo na placa-mãe de MacBook Pro após danos por líquido, substituindo componentes SMD e recuperando circuitos.',
    clientName: 'Cliente PF',
    date: '2023-10-05',
    beforeImage: '/images/portfolio/microsolda-before-1.jpg',
    afterImage: '/images/portfolio/microsolda-after-1.jpg',
    tags: ['Apple', 'MacBook', 'reparo placa'],
    featured: true
  },
  {
    id: 'rede-corporativa-completa',
    title: 'Infraestrutura de Rede Corporativa',
    category: 'infraestrutura-rede',
    categoryLabel: 'Infraestrutura de Rede',
    description: 'Projeto e implementação de infraestrutura de rede completa com cabeamento estruturado, segurança avançada e monitoramento em tempo real.',
    clientName: 'Empresa Tecnologia LTDA',
    date: '2023-04-20',
    beforeImage: '/images/portfolio/infra-before-1.jpg',
    afterImage: '/images/portfolio/infra-after-1.jpg',
    tags: ['Cisco', 'Firewall', 'Monitoramento'],
    featured: true
  },
  {
    id: 'automacao-residencial-alphaville',
    title: 'Casa Inteligente em Alphaville',
    category: 'automacao-residencial',
    categoryLabel: 'Automação Residencial',
    description: 'Implementação de sistema completo de automação residencial com controle de iluminação, climatização, segurança e entretenimento.',
    clientName: 'Residência Alphaville',
    date: '2023-02-15',
    beforeImage: '/images/portfolio/automacao-before-1.jpg',
    afterImage: '/images/portfolio/automacao-after-1.jpg',
    tags: ['Casa Inteligente', 'Controle por Voz', 'Segurança'],
    featured: true
  },
  {
    id: 'energia-solar-comercial',
    title: 'Sistema de Energia Solar Comercial',
    category: 'energia-solar',
    categoryLabel: 'Energia Solar',
    description: 'Instalação de sistema fotovoltaico completo para estabelecimento comercial, garantindo economia de 90% na conta de energia.',
    clientName: 'Comércio Local',
    date: '2023-05-12',
    beforeImage: '/images/portfolio/solar-before-1.jpg',
    afterImage: '/images/portfolio/solar-after-1.jpg',
    tags: ['Energia Renovável', 'Sustentabilidade', 'Economia'],
    featured: true
  },
  {
    id: 'recuperacao-notebook-gaming',
    title: 'Reparo de Notebook Gaming',
    category: 'manutencao',
    categoryLabel: 'Manutenção',
    description: 'Recuperação de notebook gaming de alto desempenho com problemas de superaquecimento e falhas constantes.',
    clientName: 'Cliente Gamer',
    date: '2023-07-22',
    beforeImage: '/images/portfolio/notebook-before-1.jpg',
    afterImage: '/images/portfolio/notebook-after-1.jpg',
    tags: ['Gaming', 'Refrigeração', 'Performance'],
    featured: false
  }
];

// Função de utilidade para filtrar projetos por categoria
export function getProjectsByCategory(category?: string): PortfolioProject[] {
  if (!category || category === 'todos') return portfolioProjects;
  return portfolioProjects.filter(project => project.category === category);
}

// Função para obter projetos em destaque
export function getFeaturedProjects(limit = 3): PortfolioProject[] {
  return portfolioProjects
    .filter(project => project.featured)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
}

// Função para obter projetos por categoria para CTAs de página de serviço
export function getProjectPreviewForService(category: string): PortfolioProject | null {
  const categoryProjects = getProjectsByCategory(category)
    .filter(project => project.featured)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  
  return categoryProjects.length > 0 ? categoryProjects[0] : null;
} 